import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveDirective as _resolveDirective, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25de39fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "container px-0 pb-705 pt-0"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "nobullet-list" }
const _hoisted_10 = { class: "form-group-radio" }
const _hoisted_11 = { for: "yes" }
const _hoisted_12 = { class: "form-group-radio" }
const _hoisted_13 = { for: "no" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RichText = _resolveComponent("RichText")!
  const _component_SharedHeader = _resolveComponent("SharedHeader")!
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_OverviewTableComponent = _resolveComponent("OverviewTableComponent")!
  const _component_AcceptModal = _resolveComponent("AcceptModal")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SharedHeader, { headerPadding: 'pt-8 pb-505' }, {
      firstColumn: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_RichText, { "text-key": "calculationsoverview.headerLeft" })
        ])
      ]),
      secondColumn: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: this.headerRight,
            alt: "",
            style: {"width":"50%","height":"50%"}
          }, null, 8, _hoisted_1)
        ])
      ]),
      _: 1
    }),
    (_ctx.calculations)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", null, [
            _createVNode(_component_SimpleText, { "text-key": "calculationsoverview.draftsTitle" })
          ]),
          _createVNode(_component_OverviewTableComponent, {
            id: "drafts",
            calculations: _ctx.calculations,
            versions: _ctx.versions,
            showOnly: 'draft',
            onEditCalculation: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editCalculation($event))),
            onUpdateEcvCalculation: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateECVCalculationConfirm($event))),
            onDeleteCalculation: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmDeleteCalculation($event))),
            onCompleteCalculation: _cache[3] || (_cache[3] = ($event: any) => (_ctx.completeCalculation($event))),
            onCopyCalculation: _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmCopyCalculation($event)))
          }, null, 8, ["calculations", "versions"]),
          _createElementVNode("h2", null, [
            _createVNode(_component_SimpleText, { "text-key": "calculationsoverview.finishedTitle" })
          ]),
          _createVNode(_component_OverviewTableComponent, {
            id: "finished",
            calculations: _ctx.calculations,
            versions: _ctx.versions,
            showOnly: 'finished',
            onReopenCalculation: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmReopenCalculation($event))),
            onUpdateEcvCalculation: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateECVCalculationConfirm($event))),
            onShowCalculation: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showCalculation($event))),
            onCopyCalculation: _cache[8] || (_cache[8] = ($event: any) => (_ctx.confirmCopyCalculation($event)))
          }, null, 8, ["calculations", "versions"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.calculationToDelete.id && _ctx.calculationToDelete.id > 0)
      ? (_openBlock(), _createBlock(_component_AcceptModal, {
          key: 1,
          "value-object": _ctx.calculationToDelete,
          "title-key": 'calculation.overview.delete-modal.title',
          "buttons-disabled": _ctx.disableDeleteModalButtons,
          "button-ok-text-key": 'calculation.overview.delete-modal.button.ok',
          "button-reject-text-key": 'calculation.overview.delete-modal.button.cancel',
          onSelectOk: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteCalculation($event))),
          onSelectReject: _cache[10] || (_cache[10] = ($event: any) => (_ctx.resetCalculationToDelete()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, [
                _createVNode(_component_SimpleText, { "text-key": 'calculation.overview.delete-modal.text1' }, null, 8, ["text-key"])
              ]),
              _hoisted_3,
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.calculationToDelete.calculationPurpose.name) + " ", 1),
              _hoisted_5,
              _hoisted_6,
              _createVNode(_component_SimpleText, { "text-key": 'calculation.overview.delete-modal.text2' }, null, 8, ["text-key"])
            ])
          ]),
          _: 1
        }, 8, ["value-object", "title-key", "buttons-disabled", "button-ok-text-key", "button-reject-text-key"]))
      : _createCommentVNode("", true),
    (_ctx.calculationToCopy.id && _ctx.calculationToCopy.id > 0)
      ? (_openBlock(), _createBlock(_component_AcceptModal, {
          key: 2,
          "value-object": _ctx.calculationToCopy,
          "title-key": 'calculation.overview.copy-modal.title',
          "buttons-disabled": _ctx.disableCopyModalButtons,
          "button-ok-text-key": 'calculation.overview.copy-modal.button.ok',
          "button-reject-text-key": 'calculation.overview.copy-modal.button.cancel',
          onSelectOk: _cache[13] || (_cache[13] = ($event: any) => (_ctx.copyCalculation($event))),
          onSelectReject: _cache[14] || (_cache[14] = ($event: any) => (_ctx.resetCalculationToCopy()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _createVNode(_component_SimpleText, { "text-key": 'calculation.overview.copy-modal.text1' }, null, 8, ["text-key"]),
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("strong", null, [
                _createVNode(_component_SimpleText, { "text-key": 'calculation.overview.copy-modal.text2' }, null, 8, ["text-key"])
              ])
            ]),
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    class: "form-radio",
                    name: "copy",
                    id: "yes",
                    value: "Yes",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.includeFilesWhenCopy) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.includeFilesWhenCopy]
                  ]),
                  _createElementVNode("label", _hoisted_11, [
                    _createVNode(_component_SimpleText, { "text-key": 'calculation.overview.copy-modal.radio-button.option1' }, null, 8, ["text-key"])
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    class: "form-radio",
                    name: "copy",
                    id: "no",
                    value: "No",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.includeFilesWhenCopy) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.includeFilesWhenCopy]
                  ]),
                  _createElementVNode("label", _hoisted_13, [
                    _createVNode(_component_SimpleText, { "text-key": 'calculation.overview.copy-modal.radio-button.option2' }, null, 8, ["text-key"])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["value-object", "title-key", "buttons-disabled", "button-ok-text-key", "button-reject-text-key"]))
      : _createCommentVNode("", true),
    (_ctx.calculationToReopen.id && _ctx.calculationToReopen.id > 0)
      ? (_openBlock(), _createBlock(_component_AcceptModal, {
          key: 3,
          "value-object": _ctx.calculationToReopen,
          "title-key": 'calculation.overview.reopen-modal.title',
          "buttons-disabled": _ctx.disableReopenModalButtons,
          "button-ok-text-key": 'calculation.overview.reopen-modal.button.ok',
          "button-reject-text-key": 'calculation.overview.reopen-modal.button.cancel',
          onSelectOk: _cache[15] || (_cache[15] = ($event: any) => (_ctx.unlockCalculation($event))),
          onSelectReject: _cache[16] || (_cache[16] = ($event: any) => (_ctx.resetCalculationToReopen()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, [
                _createVNode(_component_SimpleText, { "text-key": 'calculation.overview.reopen-modal.text1' }, null, 8, ["text-key"])
              ]),
              _hoisted_14,
              _hoisted_15,
              _createTextVNode(" " + _toDisplayString(_ctx.calculationToReopen.calculationPurpose.name) + " ", 1),
              _hoisted_16,
              _hoisted_17,
              _createVNode(_component_SimpleText, { "text-key": 'calculation.overview.reopen-modal.text2' }, null, 8, ["text-key"])
            ])
          ]),
          _: 1
        }, 8, ["value-object", "title-key", "buttons-disabled", "button-ok-text-key", "button-reject-text-key"]))
      : _createCommentVNode("", true),
    (_ctx.calculationToUpdateVersion.id && _ctx.calculationToUpdateVersion.id > 0)
      ? (_openBlock(), _createBlock(_component_AcceptModal, {
          key: 4,
          "value-object": _ctx.calculationToUpdateVersion,
          "title-key": 'purpose.emf.update.dialog.title',
          "buttons-disabled": _ctx.disableUpdateVersionModalButtons,
          "button-ok-text-key": 'purpose.emf.update.dialog.button.ok',
          "button-reject-text-key": 'purpose.emf.update.dialog.button.cancel',
          onSelectOk: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updateECVCalculation($event))),
          onSelectReject: _cache[18] || (_cache[18] = ($event: any) => (_ctx.resetVersion()))
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("p", null, null, 512), [
              [_directive_dompurify_html, _ctx.updateVersionText(_ctx.calculationToUpdateVersion)]
            ])
          ]),
          _: 1
        }, 8, ["value-object", "title-key", "buttons-disabled", "button-ok-text-key", "button-reject-text-key"]))
      : _createCommentVNode("", true)
  ], 64))
}